module.exports = __webpack_public_path__ + "img/Imagen2.4e168dbe.webp";